import { render, staticRenderFns } from "./AdminDashBoard.vue?vue&type=template&id=599b4a94&scoped=true&"
import script from "./AdminDashBoard.vue?vue&type=script&lang=js&"
export * from "./AdminDashBoard.vue?vue&type=script&lang=js&"
import style0 from "./AdminDashBoard.vue?vue&type=style&index=0&id=599b4a94&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "599b4a94",
  null
  
)

export default component.exports